"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoDataComponent = void 0;
const react_1 = __importDefault(require("react"));
const skeleton_and_no_data_state_styles_1 = require("./skeleton-and-no-data-state.styles");
const localization_1 = require("../../../../localization");
const NoDataComponent = () => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    return (react_1.default.createElement(skeleton_and_no_data_state_styles_1.NoDataContainer, null, react_1.default.createElement("p", { className: "no-data-message" }, t({ key: 'NO_DATA_AVAILABLE' }))));
};
exports.NoDataComponent = NoDataComponent;
